"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./UpcomingEventComponent.scss");
const UpcomingEventComponent = ({ link, image, title, date, descriptionXHtml, ctaText, isSingle, eventPageNotVisible }) => {
    const eventdata = react_1.default.createElement(react_1.default.Fragment, null,
        image && react_1.default.createElement("img", { className: `${isSingle ? 'mb-8' : 'mb-5'} mb-sm-0 me-sm-8 upcoming-event-image`, width: '170', height: '135', alt: "", src: image }),
        react_1.default.createElement("div", { className: "d-flex flex-column justify-content-between" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("h3", { className: "ingress" }, title),
                react_1.default.createElement("div", { className: "text-16 upcoming-event-date" }, date)),
            (isSingle && descriptionXHtml) && react_1.default.createElement("p", { className: "upcoming-event-description text-16 mt-7", dangerouslySetInnerHTML: { __html: descriptionXHtml } }),
            (!isSingle && ctaText && !eventPageNotVisible) && react_1.default.createElement("div", { className: "upcoming-event-cta-text mt-sm-6" }, ctaText)));
    return eventPageNotVisible ?
        react_1.default.createElement("div", { className: `${isSingle ? 'upcoming-event upcoming-event-single' : 'upcoming-event'} d-flex flex-column flex-sm-row fw-normal` }, eventdata)
        :
            react_1.default.createElement("a", { className: `${isSingle ? 'upcoming-event upcoming-event-single' : 'upcoming-event'} d-flex flex-column flex-sm-row fw-normal`, href: link }, eventdata);
};
exports.default = UpcomingEventComponent;
